import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

import { UnitsEnum, UnitsEnumHelpers } from '~core/models/enums/units.enum';

@Component({
    selector: 'arc-quantity-unit-display',
    templateUrl: './quantity-unit-display.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatTooltip, TranslocoPipe]
})
export class QuantityUnitDisplayComponent {
    @HostBinding('class') classes = 'truncate pl-1 text-on-app-light';
    @HostBinding('style.max-width.px')
    get maxWidthPx(): number {
        return this.maxSuffixWidth();
    }

    readonly unitQuantity = input<number>();
    readonly unit = input<string | UnitsEnum>();
    readonly maxSuffixWidth = input<number>(62);
    readonly isUnitTranslated = input<boolean>(false);
    readonly unitText = input<string>();
    readonly unitTooltip = input<string>();
    readonly unitTextComputed = computed(() => {
        if (this.unitText()) {
            return this.unitText();
        }

        const unit = this.unit();

        if (unit === UnitsEnum.SpacedPercentSymbol) {
            return ' % ';
        } else if (!!unit && unit in UnitsEnum) {
            return UnitsEnumHelpers.getUnitShortTextKey(unit as UnitsEnum);
        } else {
            return unit || '';
        }
    });
    readonly unitTooltipComputed = computed(() => {
        if (this.unitTooltip()) {
            return this.unitTooltip();
        }

        const unit = this.unit();

        if (!unit) {
            return '';
        }

        return unit in UnitsEnum ? UnitsEnumHelpers.getUnitLongTextKey(unit as UnitsEnum) : unit || '';
    });
    readonly shouldTranslateUnit = computed(() => {
        const unit = this.unit();
        return !this.isUnitTranslated() || (unit !== undefined && unit in UnitsEnum);
    });
}
